import ko from "knockout";
import logger from "flow/logger";
import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import viewCache from "flow/utils/viewCache";
import { CloseCallback } from "flow/api/types";
import MyFlow from "flow/MyFlow";
import viewHtml from "./ErrorDialog.html";
import findCorrelationId from "flow/utils/findCorrelationId";

export interface IErrorDialogViewContext {
    title: string;
    text: string;
    showCorrelationOnly?: boolean;
}

// I create my own manifest
manifestManager.addManifests(config.moduleId, [
    {
        id: config.componentIds.error,
        isDialog: true,
        namespace: "default",
        reuseInstance: false,
        useFormValidation: false,
        viewModelId: "flow/viewModels/ErrorDialog",
        viewUrl: "virtual/ErrorDialog"
    }
]);

viewCache.inject("virtual/ErrorDialog", viewHtml);

function ErrorDialog(myFlow: MyFlow) {
    let closeFunc: CloseCallback;
    const title = ko.observable();
    const text = ko.observable();
    const errorLog = ko.observable();
    const detailsVisible = ko.observable(false);
    const showCorrelationOnly = ko.observable(false);
    const detailsText = ko.observable();
    const showDetails = ko.observable(true);
    const focusObservable = ko.observable();

    function activate(viewContext: IErrorDialogViewContext, closeCallback: CloseCallback) {
        closeFunc = closeCallback;
        title(viewContext.title);
        text(viewContext.text);
        showCorrelationOnly(
            typeof viewContext.showCorrelationOnly !== "undefined" ? viewContext.showCorrelationOnly : false
        );
        showDetails(true);
        const errorStr = logger.getErrorLog();
        if (errorStr === "" || errorStr === undefined || errorStr === null) {
            showDetails(false);
        }
        if (showCorrelationOnly()) {
            let correlationId = "";
            try {
                const msg = JSON.parse("{" + errorStr.match(/"exceptionMessage"( )*:( )*".*"/g)[0] + "}");
                if (msg.exceptionMessage.length > 0) {
                    correlationId = findCorrelationId(msg.exceptionMessage);
                }
            } catch (e) {}
            if (correlationId != undefined && correlationId.length > 0) {
                text(myFlow.translate("FlowHtml.Translations.UnexpectedErrorContactAdminWithId") + " " + correlationId);
                showDetails(false);
            }
        } else {
            errorLog(errorStr);
        }
        if (showDetails()) {
            detailsText(myFlow.translate("FlowHtml.Translations.ShowDetails"));
            detailsVisible(false);
        }

        focusObservable(true);
    }

    function close() {
        closeFunc(false);
    }

    function commands() {
        return [{ text: "OK", click: close, focusObs: focusObservable }];
    }

    function showHideDetails() {
        if (showDetails()) {
            if (detailsVisible()) {
                detailsVisible(false);
                detailsText(myFlow.translate("FlowHtml.Translations.ShowDetails"));
            } else {
                detailsVisible(true);
                detailsText(myFlow.translate("FlowHtml.Translations.HideDetails"));
            }
        }
    }

    function getDimensions(maxWidth: number, _maxHeight: number) {
        return {
            width: Math.min(maxWidth - 24, 600),
            height: "auto"
        };
    }

    return {
        commands: commands,
        activate: activate,
        componentTitle: title,
        text: text,
        errorLog: errorLog,
        showHideDetails: showHideDetails,
        detailsVisible: detailsVisible,
        detailsText: detailsText,
        showDetails: showDetails,
        showCorrelationOnly: showCorrelationOnly,
        getDimensions: getDimensions
    };
}

export default ErrorDialog;
